import shoppingList from './shoppingList';
import instructions from './instructions';
import ideas from './ideas';
import ingredients from './ingredients';



const TOOLS = [

    ideas,
    ingredients,
    instructions,
    shoppingList,

]

export default TOOLS
